var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11.7857C4.44772 11.7857 4 11.306 4 10.7143V4.28571C4 3.69398 4.44772 3.21428 5 3.21428C5.55228 3.21428 6 3.69398 6 4.28571V10.7143C6 11.306 5.55228 11.7857 5 11.7857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3.21428C12.4477 3.21428 12 3.69398 12 4.28571V10.7143C12 11.306 12.4477 11.7857 13 11.7857C13.5523 11.7857 14 11.306 14 10.7143V4.28571C14 3.69398 13.5523 3.21428 13 3.21428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.14286C0 0.959389 0.89543 0 2 0H16C17.1046 0 18 0.95939 18 2.14286V12.8571C18 14.0406 17.1046 15 16 15H2C0.89543 15 0 14.0406 0 12.8571V2.14286ZM3.8 1.66667C2.69543 1.66667 1.8 2.62606 1.8 3.80953V11.1904C1.8 12.3739 2.69543 13.3333 3.8 13.3333H14.2C15.3046 13.3333 16.2 12.3739 16.2 11.1904V3.80953C16.2 2.62606 15.3046 1.66667 14.2 1.66667H3.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlex);
export default __webpack_public_path__ + "static/media/flex.08483babbba1c7c727a4637b4a911224.svg";
export { ForwardRef as ReactComponent };